import router from './routers'
import store from '@/store'
import Config from '@/settings'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie
import { buildMenus } from '@/api/system/menu'
import { filterAsyncRouter } from '@/store/modules/permission'

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/login', '/forget', '/regist', '/entSelfRegister']// no redirect whitelist

router.beforeEach(async(to, from, next) => {


  console.log('平台信息', store.state.user.platformInfo)
  // 拉取平台信息（失败不阻断路由，如密码过期返回 533 时由全局弹窗处理）
  if (!store.state.user.platformInfo) {
    try {
      await store.dispatch('GetAccessPlatformInfo')
    } catch (error) {
      // 忽略：异常已由 request 拦截器提示或触发密码过期弹窗
    }
  }
  console.log('小程序应用信息', store.state.user.wxAppInfo)
  // 拉取小程序应用信息（失败不阻断路由，如密码过期返回 533 时由全局弹窗处理）
  if (!store.state.user.wxAppInfo) {
    try {
      await store.dispatch('GetWxAppInfo')
    } catch (error) {
      // 忽略：异常已由 request 拦截器提示或触发密码过期弹窗
    }
  }

  // 统计访问量
  statisticVisitedMenu(to.path)

  if (to.query.website_redirect) {
    try {
      if (!getToken()) {
        throw new Error('未登录')
      }
      else if (to.query.website_relogin) {
        window.sessionStorage.setItem('website_redirect', to.query.website_redirect)
        return await store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      }
      await store.dispatch('GetInfo')
      return location.href = (`${to.query.website_redirect}?tk=${getToken()}`)
    }
    catch (error) {
      window.sessionStorage.setItem('website_redirect', to.query.website_redirect)
    }
  }
  if (to.meta.title) {
    document.title = to.meta.title + ' - ' + Config.title
  }
  NProgress.start()
  if (getToken()) {
    // 已登录且要跳转的页面是登录页
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (to.matched.length === 0) {
        next({ path: '/' }) // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到首页
      }
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(res => { // 拉取user_info
          // 动态路由，拉取菜单
          loadMenus(next, to)
          store.dispatch('GetEntBusinessInfo').catch(() => {})
          store.dispatch('GetVerifyInfo').catch(() => {})
        }).catch((err) => {
          // 密码已过期（533）时不能退出登录，保持页面并展示强制修改密码弹窗
          if (store.state.user.pwdExpired) {
            next()
            return
          }
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
        // 登录时未拉取 菜单，在此处拉取
      } else if (store.getters.loadMenus) {
        // 修改成false，防止死循环
        store.dispatch('updateLoadMenus').then(res => { })
        loadMenus(next, to)
      } else {
        next()
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

export const loadMenus = (next, to) => {
  buildMenus().then(res => {
    const traverseTree = (list = []) => {
      list.forEach(item => {
        item.meta.id = item.id
        item.children && item.children.length && traverseTree(item.children)
      })
    }
    traverseTree(res)
    const asyncRouter = filterAsyncRouter(res)
    asyncRouter.push({ path: '*', redirect: '/401', hidden: true })
    store.dispatch('GenerateRoutes', asyncRouter).then(() => { // 存储路由
      router.addRoutes([...asyncRouter]) // 动态添加可访问路由表
      console.log('已添加的路由表', router)
      next({ ...to, replace: true })
    })
  }).catch(() => {
    // 密码已过期（533）时拉不到菜单，仍需放行路由，避免卡住或跳到登录页
    if (store.state.user.pwdExpired) {
      next()
    }
  })
}

const statisticVisitedMenu = (path) => {
  setTimeout(() => {
    const routerMenuOptions = store.state.permission.routerMenuOptions
    if (!(routerMenuOptions && routerMenuOptions.length)) return
    // 统计访问量
    const visitedMenuOption = routerMenuOptions.find(item => item.value == path)
    if (visitedMenuOption) {
      let recommendOptions = window.localStorage.getItem('MENU_RECOMMEND_OPTIONS_' + store.getters.user.id)
      recommendOptions = JSON.parse(recommendOptions) || []
      const recommendOption = recommendOptions.find(item => {
        if (!item.visitedCount) item.visitedCount = 0;
        if (item.value == visitedMenuOption.value) {
          item.visitedCount++;
          return true
        }
      })
      if (!recommendOption) {
        recommendOptions.push({ ...visitedMenuOption, visitedCount: 1 })
      }
      // 排序
      recommendOptions = recommendOptions.sort((a, b) => b.visitedCount - a.visitedCount);

      window.localStorage.setItem(
        "MENU_RECOMMEND_OPTIONS_" + store.getters.user.id,
        JSON.stringify(recommendOptions)
      );
    }
  }, 0);
}
router.afterEach(() => {
  NProgress.done() // finish progress bar
})
